/**
 * Clock icon for pending/in-progress timeline events.
 * Color: Gray (#9CA3AF) for pending events
 * Size controlled by CSS: 16x16
 */
export const ClockIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="12" fill="#E5E7EB" />
    <circle cx="12" cy="12" r="8" stroke="#6B7280" strokeWidth="1.5" fill="none" />
    <path
      d="M12 8V12L14.5 14.5"
      stroke="#6B7280"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
